import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'lib-nav-toggle',
  templateUrl: './nav-toggle.component.html',
  styleUrls: ['./nav-toggle.component.scss'],
  standalone: false,
})
export class NavToggleComponent {
  @Input() isOpen = true;
  @Output() navToggle = new EventEmitter<void>();

  onToggle(): void {
    this.navToggle.emit();
  }
}
